import { render } from "./WalletLink.vue?vue&type=template&id=b0168184&scoped=true"
import script from "./WalletLink.vue?vue&type=script&lang=js"
export * from "./WalletLink.vue?vue&type=script&lang=js"

import "./WalletLink.vue?vue&type=style&index=0&id=b0168184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0168184"]])

export default __exports__